import React from "react";
import { Monogram } from "@/components/Logo";

// Navy header band used at the top of every form card.
export const FormHeader = ({ icon: Icon, title, subtitle, children, className = "", testid = "form-header" }) => (
  <div className={`form-head bg-findo-navy text-white px-6 sm:px-8 py-5 flex items-start gap-3.5 ${className}`} data-testid={testid}>
    <span className="dlg-icon shrink-0 mt-0.5" aria-hidden="true">{Icon ? <Icon size={19} /> : <Monogram size={22} />}</span>
    <div className="min-w-0 flex-1">
      <p className="font-display text-lg sm:text-xl font-semibold leading-tight text-white">{title}</p>
      {subtitle && <p className="mt-1 text-sm text-white/70 leading-relaxed">{subtitle}</p>}
      {children}
    </div>
  </div>
);

// White card: navy header + airy body with numbered field labels.
export const FormCard = ({ icon, title, subtitle, header, children, className = "", bodyClassName = "", testid }) => (
  <div className={`form-card bg-white rounded-3xl border border-border overflow-hidden ${className}`} data-testid={testid}>
    <FormHeader icon={icon} title={title} subtitle={subtitle}>{header}</FormHeader>
    <div className={`findo-form-body p-6 sm:p-8 ${bodyClassName}`}>{children}</div>
  </div>
);

// "Étape 1/2" progress bar shown inside the navy header.
export const StepProgress = ({ step, total = 2, labels = [], t }) => (
  <div className="mt-4" data-testid="form-step-progress">
    <div className="flex items-center justify-between text-[11px] font-bold uppercase tracking-wider text-white/80">
      <span data-testid="form-step-label">{(t ? t("form.step") : "Étape")} {step}/{total}</span>
      {labels[step - 1] && <span className="normal-case tracking-normal font-semibold text-white">{labels[step - 1]}</span>}
    </div>
    <div className="mt-2 h-1.5 rounded-full bg-white/15 overflow-hidden">
      <div className="h-full rounded-full bg-findo-red transition-[width] duration-500 ease-out" style={{ width: `${(step / total) * 100}%` }} />
    </div>
  </div>
);
